import { Link } from 'react-router';
import ClockIcon from '@/assets/icons/clock.svg?react';
import { LINKS } from '@/shared/config/links';
import { ROUTES } from '@/shared/config/routes';
import { BadgeIcon } from '@/shared/ui/badge-icon';
import { Button } from '@/shared/ui/button';
import { Card } from '@/shared/ui/card';

export function ActivationTimeoutCard({ planName }: { planName: string }) {
  return (
    <Card asChild>
      <section
        data-enter=""
        className="mx-auto mt-12 flex max-w-140 shrink grow basis-full flex-col gap-4.5 p-8"
      >
        <BadgeIcon tone="warn">
          <ClockIcon className="size-5.5" />
        </BadgeIcon>
        <div className="flex flex-col gap-2" role="status">
          <h1 className="font-semibold text-title">{planName} is still turning on</h1>
          <p className="text-muted">
            Paddle took the payment and the plan is on its way. Check Billing in a minute. If it is
            not there in ten minutes, write to {LINKS.SUPPORT_EMAIL}.
          </p>
        </div>
        <Button asChild variant="primary" size="lg" className="self-start">
          <Link to={ROUTES.BILLING}>Go to billing</Link>
        </Button>
      </section>
    </Card>
  );
}
